// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"user-search"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 7.5C16 9.98528 13.9853 12 11.5 12C9.01472 12 7 9.98528 7 7.5C7 5.01472 9.01472 3 11.5 3C13.9853 3 16 5.01472 16 7.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21.5 17.75C21.5 19.8211 19.8211 21.5 17.75 21.5C15.6789 21.5 14 19.8211 14 17.75C14 15.6789 15.6789 14 17.75 14C19.8211 14 21.5 15.6789 21.5 17.75Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.5 15H8C5.23858 15 3 17.2386 3 20V21H10.5508M16 7.5C16 9.98528 13.9853 12 11.5 12C9.01472 12 7 9.98528 7 7.5C7 5.01472 9.01472 3 11.5 3C13.9853 3 16 5.01472 16 7.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20.4979 20.5L22 22M21.5 17.75C21.5 19.8211 19.8211 21.5 17.75 21.5C15.6789 21.5 14 19.8211 14 17.75C14 15.6789 15.6789 14 17.75 14C19.8211 14 21.5 15.6789 21.5 17.75Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UserSearchIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-search',
    ref,
    icon: element,
  },
));

UserSearchIcon.displayName = 'UserSearchIcon';

export default UserSearchIcon;
